module.exports = __webpack_public_path__ + "img/Illustration-01.07c1d650.png";